import React from "react"
import { FaPhone } from "react-icons/fa"
// import { HiOutlinePhone, HiOutlineMail, HiBadgeCheck } from "react-icons/hi"

const PhoneFloat = ({ phones }) => (
  <a
    id="phonefloat"
    href={`tel:+${phones.replace(/\D/g, "")}`}
    className="float-button-phone bg-success float-icon"
    target="_blank"
    rel="noopener noreferrer nofollow"
  >
    <FaPhone className="fa-icon-phone" />
  </a>
)

PhoneFloat.defaultProps = {
  phones: `+380683328808`,
}

export default PhoneFloat
